<template>
  <!-- <div class="container mx-auto px-12"> -->
        <form method="POST" :action="reset">
        <input type="hidden" name="_token" :value="csrf">
            <div class="py-16">
                <div class="flex flex-row">
                    <div class="flex-col w-10/12 sm:w-5/6 md:w-3/5 mx-auto">
                        <div class="justify-center text-center text-2xl text-gray-700">
                           <slot :item="item"></slot>
                        </div>
                    </div>
                </div>

                <div v-if="sessionStatus" class="text-sm border border-t-8 mx-8 mt-10 rounded text-green-700 border-green-600 bg-green-100 px-3 py-4 mb-4" role="alert">
                    {{sessionStatus}}
                </div>

                <div v-else>
                    <div class="flex flex-row mt-10 sm:pl-2 md:pl-0">
                        <div class="pt-2 md:pt-1 w-4/20 md:w-6/20 lg:w-7/20 md:pr-6 text-right text-sm md:text-base text-gray-600">
                            Email
                        </div>
                        <div class="w-full md:w-6/12 lg:w-5/12 pl-5 md:pl-2 md:pl-0">
                            <input
                                class="form-input w-full py-2 md:py-1 px-4 bg-gray-200"
                                :class="errorEmail ? 'border-red-400' : ''"
                                type="text"
                                placeholder="john@doe.com"
                                name="email"
                                id="email"
                                value="" 
                                v-model="email" 
                                @blur="emailCheck"
                                equired autofocus>
                            <div class="text-red-500 text-xs" v-html="errorDisplay"></div>
                        </div>
                    </div>

                    <div id="email-validate" class="hidden flex flex-row sm:pl-2 md:pl-0">
                        <div class="flex flex-col w-5/20 md:w-6/20 lg:w-7/20"></div>
                        <div class="flex flex-col ml-2 md:w-full md:w-6/12 lg:w-5/12 text-red-500 text-xs">
                            Please enter a valid email address
                        </div>
                    </div>

                    <div id="email-error" class="flex flex-row sm:pl-2 md:pl-0">
                        <div class="flex flex-col ml-12 md:ml-6 w-full md:w-6/12 lg:w-5/12 text-red-500 text-xs" :class="errorEmail ? 'block' : 'hidden'">

                        </div>
                    </div>

                    <div class="flex flex-row mt-10">
                        <button
                            type="submit"
                            id="login-button"
                            class="mx-auto w-full md:w-6/20 lg:w-8/20 py-3 w-full text-center text-sm rounded-full bg-blue-400 text-white hover:bg-blue-500 focus:outline-none">
                                Send Password Reset Link
                        </button>
                    </div>
                </div>

            </div>
        </form>
    <!-- </div> -->
</template>

<script>
export default {
    name: "reset-password",
    props: [
        'item',
        'csrf', 
        'emailAddress', 
        'reset', 
        'sessionStatus',
        'errorDisplay',
        'errorEmail'
    ],
    data() {
        return {
            email: '',
            csrfToken: ''
        }
    },
    mounted(){
        this.documentReadyFunction();

    },
    created(){
        this.email = this.emailAddress;
    },
    methods: {
        documentReadyFunction() {
            let emailError = document.getElementById('email-error');
            let emailForm = document.getElementById('email');
           
            if (emailError) {
                if (emailError.classList.contains('hidden')) {
                    if (this.validateEmail(this.email)) {
                        emailForm.classList.remove('bg-gray-200')
                        emailForm.classList.add('border-teal-400', 'bg-white')
                    }
                }

                if (!emailError.classList.contains('hidden')) {
                    emailForm.classList.remove('bg-gray-200');
                    emailForm.classList.add('bg-white', 'border-red-400');
                }
            }
        },

        emailCheck() {
            let emailForm = document.getElementById('email');
            let emailError = document.getElementById('email-error');
            let emailValidate = document.getElementById('email-validate');

            if (this.validateEmail(this.email)) {
                emailForm.classList.remove('bg-gray-200', 'border-red-400');
                emailForm.classList.add('border-teal-400', 'bg-white');
                emailError.classList.add('hidden');
                emailValidate.classList.add('hidden');
            } else {
                emailForm.classList.remove('bg-gray-200', 'border-teal-400');
                emailForm.classList.add('border-red-400', 'bg-white');
                emailValidate.classList.remove('hidden');
            }
        },

        validateEmail(email){
            return email.match(
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        }
    }
}
</script>

<style>

</style>